import {useMediaQuery, useTheme} from '@material-ui/core';
import React from 'react';
import {RouteConfig, RouteConfigComponentProps} from 'react-router-config';

interface IRoute {
  path: string;
  component:
    | React.ComponentType<RouteConfigComponentProps<any>>
    | React.ComponentType;
  auth?: string[];
}

interface IContainerRoute {
  routes: RouteConfig[];
  auth?: string[];
}

export const useBreakPointDown = (
  key: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(key));
};

export const createRoutes = (routeConfigs: RouteConfig[]): RouteConfig[] => {
  let allRoutes: RouteConfig[] = [];
  routeConfigs.forEach((config) => {
    allRoutes = [...allRoutes, ...setRoutes(config)];
  });
  return allRoutes;
};

export const setRoutes = (config: RouteConfig): RouteConfig[] => {
  let routes = [...(config.routes ?? [])];
  if (config.auth) {
    routes = routes.map((route) => {
      const auth = route.auth
        ? [...(config.auth ?? []), ...route.auth]
        : [...(config.auth ?? [])];
      return {...route, auth};
    });
  }

  return [...routes];
};
export const getBreakPointsValue = (
  valueSet:
    | number
    | {xs?: number; sm?: number; md?: number; lg?: number; xl?: number},
  breakpoint: string,
): number => {
  if (typeof valueSet === 'number') return valueSet;

  switch (breakpoint) {
    case 'xs':
      return valueSet.xs ?? 0;
    case 'sm':
      return (valueSet.sm ?? 0) || (valueSet.xs ?? 0);
    case 'md':
      return (valueSet.md ?? 0) || (valueSet.sm ?? 0) || (valueSet.xs ?? 0);
    case 'lg':
      return (
        (valueSet.lg ?? 0) ||
        (valueSet.md ?? 0) ||
        (valueSet.sm ?? 0) ||
        (valueSet.xs ?? 0)
      );
    default:
      return (
        valueSet.xl! ||
        valueSet.lg! ||
        valueSet.md! ||
        valueSet.sm! ||
        valueSet.xs!
      );
  }
};
